import './style.css'

import { Switcher } from './switcher.ts'
import ButtonsPanel from './ButtonsPanel.ts'


// Подключение Switcher на страницу
const initSwitcher = (mountElements:NodeListOf<HTMLDivElement>) => {
  if(!mountElements.length) {
    console.log('Не определен целевой блок для переключателя размера!')
  }
  
  mountElements.forEach((mountEl) => {
    const switcher = new Switcher(mountEl)
    switcher.setup()
  })
}

// Подключение Switсher для следующих загруженных элементов пагинации
document.addEventListener('pageLoad', (e:Event) => {
  const tmp = document.createElement('div')
  const itemsList = (<CustomEvent>e).detail


  itemsList.forEach((item:Node) => {
    tmp.appendChild(item)
  })

  const switcherList:NodeListOf<HTMLDivElement> = tmp.querySelectorAll('.js-size-switcher')

  if(!switcherList) {
    console.log('Не найден список элементов для подключения')
    return
  }

  initSwitcher(switcherList)
})


const initButtonsPanel = (mountElements:NodeListOf<HTMLDivElement>) => {
  if(!mountElements.length) {
    console.log('Не определен целевой блок для блока кнопок!')
    return
  }
  
  mountElements.forEach((mountEl) => {
    const buttonsPanel = new ButtonsPanel(mountEl)
    buttonsPanel.setup()
  })
}

initSwitcher(document.querySelectorAll<HTMLDivElement>('.js-size-switcher'))
initButtonsPanel(document.querySelectorAll<HTMLDivElement>('.js-buttons-panel'))